import { SettingsPayrollConceptFragment } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import type { LegalEntities } from 'modules/core/store/collections/legalEntities'

export interface SettingsPayrollConceptWithLegalEntity
  extends Omit<SettingsPayrollConceptFragment, 'id'> {
  id: string
  name: string
  legalEntityName: string
  legalEntityId: number
}

export const buildPayrollConceptsByLegalEntitySettings = (
  concepts: SettingsPayrollConceptFragment[],
  legalEntities: LegalEntities
): SettingsPayrollConceptWithLegalEntity[] => {
  const conceptsExcludingSalary = concepts?.filter((concept) => concept.name !== 'base_salary')
  return legalEntities
    .map((legalEntity) =>
      conceptsExcludingSalary.map((concept) => {
        if (!legalEntity.id || !legalEntity.name) return null
        return {
          ...concept,
          id: `payroll_concept_code_${legalEntity.id}_${concept.id}`,
          name: concept.translatedName || concept.name,
          legalEntityName: capitalize(legalEntity.name),
          legalEntityId: legalEntity.id,
        }
      })
    )
    .flat()
    .filter((concept) => concept !== null)
}
